import { createContext, useContext, useEffect, useState } from "react";

export const CONTACT = {
  phone: "+48 575 247 698",
  tel: "tel:+48575247698",
  wa: "48575247698",
  email: "contact@transcars.eu",
  ig: "https://instagram.com/transcars.eu",
  igHandle: "@transcars.eu",
  nip: "PL6861697112",
};

export const waLink = (text) => `https://wa.me/${CONTACT.wa}?text=${encodeURIComponent(text)}`;

const pl = {
  nav: { services: "Usługi", routes: "Kierunki", fleet: "Realizacje", quote: "Wycena", call: "Zadzwoń" },
  hero: {
    eyebrow: "Transport samochodów · PL ↔ EU",
    lines: ["Dowozimy", "nie tylko auta,", "ale i jakość."],
    sub: "Profesjonalny transport samochodów z Niemiec, Holandii, Belgii, Francji i wielu innych krajów. Import i eksport — bezpiecznie, terminowo, z kontaktem na każdym etapie.",
    cta: "Zapytaj o wycenę",
    wa: "Napisz na WhatsApp",
    scroll: "Przewiń",
  },
  stats: [
    { v: "0%", l: "uszkodzeń samochodów" },
    { v: "350 000 €", l: "ubezpieczenie OCP przewoźnika" },
    { v: "EU", l: "licencja na transport międzynarodowy" },
    { v: "PL ↔ DE", l: "główny kierunek · import / eksport" },
  ],
  marquee: ["Polska", "Niemcy", "Holandia", "Belgia", "Francja", "Import", "Eksport", "OCP 350 000 €", "Licencja EU"],
  services: {
    eyebrow: "01 — Dlaczego Transcars",
    title: ["Twoje auto.", "Nasza odpowiedzialność."],
    items: {
      safe: { t: "Bezpieczny transport", d: "Każde auto mocowane pasami na kołach. Ubezpieczenie OCP do 350 000 € i 0% uszkodzeń." },
      time: { t: "Terminowe dostawy", d: "Ustalamy termin odbioru i dostawy — i go dotrzymujemy." },
      contact: { t: "Stały kontakt", d: "Telefon i WhatsApp na każdym etapie trasy." },
      fleet: { t: "Nowoczesna flota", d: "Lawety Iveco Daily oraz ciągnik Mercedes Actros L z przyczepą do przewozu aut." },
      drivers: { t: "Doświadczeni kierowcy", d: "Znamy europejskie trasy, place aukcyjne i salony. Auto trafia w dobre ręce." },
      ie: { t: "Import — Eksport", d: "Sprowadzamy auta do Polski i wywozimy je za granicę. Od drzwi do drzwi." },
    },
  },
  routes: {
    eyebrow: "02 — Kierunki",
    title: ["Cała Europa", "na jednej lawecie."],
    lead: "Najczęściej jeździmy na trasie Polska ↔ Niemcy, ale realizujemy transport w całej Unii Europejskiej.",
    list: [
      { c: "Niemcy", k: "DE", n: "Główny kierunek" },
      { c: "Holandia", k: "NL", n: "Regularne kursy" },
      { c: "Belgia", k: "BE", n: "Regularne kursy" },
      { c: "Francja", k: "FR", n: "Na zamówienie" },
      { c: "I wiele innych", k: "EU", n: "Zapytaj o trasę" },
    ],
    steps: [
      { t: "Zapytanie", d: "Wyślij trasę i dane auta — formularzem lub na WhatsApp." },
      { t: "Odbiór", d: "Odbieramy auto z salonu, placu lub spod domu." },
      { t: "Dostawa", d: "Dowozimy pod wskazany adres, w ustalonym terminie." },
    ],
  },
  fleet: {
    eyebrow: "03 — Realizacje",
    title: ["Prawdziwe auta.", "Prawdziwe trasy."],
    caps: ["Mercedes Actros L — autotransporter nocą", "Iveco Daily z przyczepą — dwa pojazdy naraz", "Nocny kurs — Iveco z dwoma SUV-ami"],
    ig: "Więcej na Instagramie",
  },
  quote: {
    eyebrow: "04 — Wycena",
    title: ["Gdzie jedziemy?"],
    lead: "Zostaw numer telefonu i kilka słów o aucie oraz trasie. Oddzwonimy z wyceną.",
    name: "Imię (opcjonalnie)",
    phone: "Numer telefonu *",
    from: "Skąd",
    to: "Dokąd",
    msg: "Wiadomość * — marka, model, termin…",
    send: "Wyślij zapytanie",
    sending: "Wysyłanie…",
    viaWa: "lub wyślij przez WhatsApp",
    ok: "Dziękujemy! Oddzwonimy wkrótce.",
    err: "Nie udało się wysłać. Zadzwoń lub napisz na WhatsApp.",
    invalid: "Podaj numer telefonu i wiadomość.",
    waIntro: "Dzień dobry, chciałbym zapytać o transport auta.",
  },
  footer: { tag: "Transport samochodów", rights: "Wszelkie prawa zastrzeżone." },
  waDefault: "Dzień dobry, chciałbym zapytać o transport auta.",
};

const en = {
  nav: { services: "Services", routes: "Routes", fleet: "Deliveries", quote: "Quote", call: "Call" },
  hero: {
    eyebrow: "Car transport · PL ↔ EU",
    lines: ["We deliver", "not just cars,", "but quality."],
    sub: "Professional car transport from Germany, the Netherlands, Belgium, France and many more countries. Import and export — safe, on time, with contact at every stage.",
    cta: "Get a quote",
    wa: "Message on WhatsApp",
    scroll: "Scroll",
  },
  stats: [
    { v: "0%", l: "vehicle damage" },
    { v: "€350,000", l: "carrier OCP insurance" },
    { v: "EU", l: "international transport licence" },
    { v: "PL ↔ DE", l: "main route · import / export" },
  ],
  marquee: ["Poland", "Germany", "Netherlands", "Belgium", "France", "Import", "Export", "OCP €350,000", "EU Licence"],
  services: {
    eyebrow: "01 — Why Transcars",
    title: ["Your car.", "Our responsibility."],
    items: {
      safe: { t: "Safe transport", d: "Every car secured with wheel straps. OCP insurance up to €350,000 and 0% damage." },
      time: { t: "On-time delivery", d: "We agree pickup and delivery dates — and we keep them." },
      contact: { t: "Constant contact", d: "Phone and WhatsApp at every stage of the route." },
      fleet: { t: "Modern fleet", d: "Iveco Daily car carriers and a Mercedes Actros L tractor with a car trailer." },
      drivers: { t: "Experienced drivers", d: "We know European routes, auction yards and dealerships. Your car is in good hands." },
      ie: { t: "Import — Export", d: "We bring cars to Poland and take them abroad. Door to door." },
    },
  },
  routes: {
    eyebrow: "02 — Routes",
    title: ["All of Europe", "on one carrier."],
    lead: "Our most frequent route is Poland ↔ Germany, but we transport cars across the whole European Union.",
    list: [
      { c: "Germany", k: "DE", n: "Main route" },
      { c: "Netherlands", k: "NL", n: "Regular runs" },
      { c: "Belgium", k: "BE", n: "Regular runs" },
      { c: "France", k: "FR", n: "On request" },
      { c: "And many more", k: "EU", n: "Ask about your route" },
    ],
    steps: [
      { t: "Request", d: "Send the route and car details — via the form or WhatsApp." },
      { t: "Pickup", d: "We collect the car from a dealer, yard or your home." },
      { t: "Delivery", d: "We deliver to your address on the agreed date." },
    ],
  },
  fleet: {
    eyebrow: "03 — Deliveries",
    title: ["Real cars.", "Real routes."],
    caps: ["Mercedes Actros L — car carrier at night", "Iveco Daily with trailer — two vehicles at once", "Night run — Iveco with two SUVs"],
    ig: "More on Instagram",
  },
  quote: {
    eyebrow: "04 — Quote",
    title: ["Where are we going?"],
    lead: "Leave your phone number and a few words about the car and route. We'll call you back with a quote.",
    name: "Name (optional)",
    phone: "Phone number *",
    from: "From",
    to: "To",
    msg: "Message * — make, model, date…",
    send: "Send request",
    sending: "Sending…",
    viaWa: "or send via WhatsApp",
    ok: "Thank you! We'll call you back soon.",
    err: "Could not send. Please call or message us on WhatsApp.",
    invalid: "Please enter your phone number and a message.",
    waIntro: "Hello, I'd like to ask about car transport.",
  },
  footer: { tag: "Car transport", rights: "All rights reserved." },
  waDefault: "Hello, I'd like to ask about car transport.",
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tc_lang") || "pl");
  useEffect(() => {
    localStorage.setItem("tc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: lang === "en" ? en : pl }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
